import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import type { UserView } from '../api/auth'
import { apiUrl, session } from '../api/client'
import { TESTIFY_BASE, TESTIFY_STATUSES, loadTestify, qualityRoute, testifyHeaders, ticketSearch } from '../lib/testify'

// Arms the QA widget for the signed-in person: the config is set (who they are, the bearer token the
// widget sends on every fetch including the event stream, the board's columns, and the two hooks that
// make Quality Control a PAGE of Scout's router), then the script is injected once. Called from the
// shell, i.e. after login — the widget never loads on the sign-in screen. If the script 404s the load
// resolves to null and nothing else changes: the widget is a guest, never a dependency.
export function useTestify(user: UserView | null) {
  const navigate = useNavigate()
  useEffect(() => {
    if (!user) return
    // `headers` is a GETTER: the widget reads it on every call, so a token that changes after mount (a
    // re-login, a rotation) is sent as it is now, never as it was — the stale-snapshot 401s of 2026-09-23.
    window.TESTIFY = {
      base: apiUrl(TESTIFY_BASE),
      user: { name: user.displayName },
      get headers() { return testifyHeaders(session.get()) },
      statuses: TESTIFY_STATUSES,
      navigate: (view) => navigate(qualityRoute(view)),
      onTicketOpen: (id) => navigate({ pathname: window.location.pathname, search: ticketSearch(id) }, { replace: true }),
    }
    void loadTestify()
  }, [user, navigate])
}
